import { cx } from '@emotion/css'
import React from 'react'
import {
    StyledUnmuteButton,
    StyledUnmuteButtonProps,
} from '../../../../content/Video/components/UnmuteButton/UnmuteButton.styled'

import { IconMute } from '../../../../icons/IconMute/IconMute'
import { IconSpeaker } from '../../../../icons/IconSpeaker/IconSpeaker'

interface ExtraProps {
    variant?: 'default' | 'vertical'
    isMuted?: boolean
}

export const UnmuteButton: React.FC<StyledUnmuteButtonProps & ExtraProps> = (
    props,
) => {
    const { variant = 'default', isMuted } = props

    const isCrushed = props.positionState?.alignToTop
    const isLowered = props.positionState?.isLowered && !isCrushed

    const renderIcon = () => {
        if (variant === 'vertical') {
            return isMuted ? <IconMute /> : <IconSpeaker volume={3} />
        }

        return <IconMute />
    }

    return (
        <StyledUnmuteButton
            className={cx({
                isCrushed,
                isLowered,
                verticalVariant: variant === 'vertical',
            })}
            onClick={props.action}
            type="button"
        >
            {renderIcon()}
            {variant === 'default' && ' Click to unmute'}
        </StyledUnmuteButton>
    )
}
